/* globals LogEntry */
function Log (version, includeTimestampsInXml, rootName) {
    this.entries = [];
    this.rootName = typeof rootName !== "undefined" ? rootName : "scp-log";
    this.includeTimestamps = includeTimestampsInXml;
    this.version = version;
    this.browser = navigator.userAgent;
}

Log.prototype.startNew = function (recordType, args) {
    var logEntry,
        functionName;

    if (typeof args === "string") {
        functionName = args;
        logEntry = new LogEntry(recordType, functionName);
    }
    else if (args !== null && typeof args !== "undefined") {
        functionName = args.callee.toString().substring(9, args.callee.toString().indexOf("{") - 1);
        logEntry = new LogEntry(recordType, functionName, args);
    }
    else {
        logEntry = new LogEntry(recordType, "unknown entry point");
    }

    this.entries.push(logEntry);

    return logEntry;
};
